/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import Select from "react-select";
import {
  Button,
  ButtonToolbar,
  Modal,
  Table,
  Form,
  Col,
} from "react-bootstrap";
import swal from "sweetalert";
import { NoticeManajemenUser } from "../../../../../_metronic/_partials/controls";
import { Link } from "react-router-dom";
import AppConfig from "../../../../config/AppConfig";


class ManajemenUser extends Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal1 = this.closeModal1.bind(this);
    this.closeModal2 = this.closeModal2.bind(this);
    this.modalAddURole = this.modalAddURole.bind(this);
    this.modalURole = this.modalURole.bind(this);
  }
  state = {
    // MODAL ============================
    modalAddURole: false,
    modalURole: false,
    // ==================================
    loadingBtn: false,
    loadingForm: true,
    loadingList: true,
    loadingDetails: true,
    // ==================================
    getUserRoles: [],
    getRoles: [],
    getUnits: [],
    errors: [],
    // FORM Add User
    nm_pengguna: "",
    alamat: "",
    jenis_kelamin: "",
    no_tel: "",
    username: "",
    no_hp: "",
    password: "",
    passwordconf: "",
    ym: "",
    tempat_lahir: "",
    skype: "",
    tgl_lahir: "",
    a_aktif: "",
    jabatan: "",
    // FORM Add User Role
    id_pengguna: "",
    id_peran: "",
    id_bp: "",
    id_unit: "",
    id_organisasi: "",
    no_sk_penugasan: "",
    tanggal_penugasan: "",
    id_sp: "",
    nm_sp: "",
    list_option_sp:[],
    spHide: false,
     errors: [],
  };

  closeModal1() {
    this.setState({
      modalURole: false,
      loadingBtn: false,
    });
  }

  closeModal2() {
    this.setState({
      modalAddURole: false,
      id_unit: "",
      id_peran: "",
      id_bp: "",
      no_sk_penugasan: "",
      tanggal_penugasan: "",
      loadingBtn: false,
    });
  }

  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  selectedGender = (val) => {
    this.setState({
      jenis_kelamin: val.value,
    });
  };
  selectedRole = (val) => {
    this.setState({
      id_peran: val.value,
    });
  };
  selectedBp = (val) => {
    this.setState({ val });
    this.setState({
      id_bp: val.value,
    });
  };
  selectedUnit = (val) => {
    this.setState({
      id_unit: val.value,
    });
  };

  componentDidMount() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    if(sessiondata.i_idrole !== 1 && sessiondata.i_idrole !== 10) {
       window.location.href = "/"; 
    }
    const timer = setTimeout(() => this.setState({ loadingForm: false }), 1000);
    return () => clearTimeout(timer);
  }

  validateForm() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.nm_pengguna) {
      formIsValid = false;
      errors["nm_pengguna"] = "Isian nama user tidak boleh kosong.";
    }

    if (!this.state.username) {
      formIsValid = false;
      errors["username"] = "Isian username tidak boleh kosong.";
    }

    if (!this.state.ym) {
      formIsValid = false;
      errors["ym"] = "Isian email tidak boleh kosong.";
    }

    if (!this.state.password) {
      formIsValid = false;
      errors["password"] = "Isian password tidak boleh kosong.";
    }

    if (!this.state.passwordconf) {
      formIsValid = false;
      errors["passwordconf"] = "Isian konfirmasi password tidak boleh kosong.";
    } else if (this.state.passwordconf !== this.state.password) {
      formIsValid = false;
      errors["passwordconf"] = "Isian konfirmasi password tidak sesuai.";
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  // Submit User ============================================================================
  handleSave = (e) => {
    e.preventDefault();
    e.target.className += " was-validated";
    if (this.validateForm()) {
      const {
        nm_pengguna,
        alamat,
        jenis_kelamin,
        no_tel,
        username,
        no_hp,
        password,
        passwordconf,
        ym,
        tempat_lahir,
        tgl_lahir,
      } = this.state;
      this.setState({ loadingBtn: true });
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        session =
          // "?token="+userdata.token+`
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          sessiondata.i_idunit +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      var formData = new FormData();
      formData.append("data[username]", username);
      formData.append("data[nm_pengguna]", nm_pengguna);
      formData.append("data[tempat_lahir]", tempat_lahir);
      formData.append("data[tgl_lahir]", tgl_lahir);
      formData.append("data[jenis_kelamin]", jenis_kelamin);
      formData.append("data[alamat]", alamat);
      formData.append("data[ym]", ym);
      formData.append("data[no_tel]", no_tel);
      formData.append("data[no_hp]", no_hp);
      formData.append("data[password]", password);
      formData.append("data[passwordconf]", passwordconf);
      axios
        .post(AppConfig.SaveManajemenUser + session, formData)
        .then((res) => {
          this.setState({
            loadingBtn: false,
            id_pengguna: res.data.result.data.id_user,
          });
          console.log(res);
          if (res.data.status === "sukses") {
            swal({
              title: "Sukses!",
              text: "Data user berhasil disimpan!",
              icon: "success",
              button: "Pilih Role!",
            }).then(() => {
              this.modalURole();
            });
          } else {
            swal({
              title: "Gagal!",
              text: res.data.message,
              icon: "error",
              button: "OK!",
            });
          }
        })
        .catch((err) => {
          swal({
            title: "Gagal!",
            text: "Gagal menyimpan data!",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
        });
    }
  };

  // List User Role ============================================================================
  modalURole = () => {
    console.log(this.state.id_pengguna);
    this.setState({ modalURole: true, loadingList: true });
    axios
      .get(AppConfig.ListRole + this.state.id_pengguna)
      .then((res) => {
        this.setState(
          {
            getUserRoles: res.data.result.role,
            loadingList: false,
          },
          () => {
            // console.log(this.state.getUserRoles);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Add User Role ============================================================================
  modalAddURole = () => {
    this.setState({ modalAddURole: true, loadingDetails: true });
    axios
      .get(AppConfig.AddRole + this.state.id_pengguna)
      .then((res) => {
        this.setState({
          getRoles: res.data.result.data2[0],
          getUnits: res.data.result.units[0],
          loadingDetails: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  validateFormRole() {
    let errors = [];
    let formIsValid = true;

    if (!this.state.id_peran) {
      formIsValid = false;
      errors["id_peran"] = "Isian peran tidak boleh kosong.";
    }

    if (!this.state.id_bp) {
      formIsValid = false;
      errors["id_bp"] = "Isian bentuk pendidikan tidak boleh kosong.";
    }

    if(this.state.id_peran === '3'){
      if (!this.state.id_sp) {
        formIsValid = false;
        errors["id_sp"] = "Isian perguruan tinggi tidak boleh kosong.";
      }
    }else if(this.state.id_peran === '2013' || this.state.id_peran === '2014'){
      if (!this.state.id_unit) {
        formIsValid = false;
        errors["id_unit"] = "Isian unit tidak boleh kosong.";
      }
    }

    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleSubmitRole = (e) => {
    e.preventDefault();
    if (this.validateFormRole()) {
    var formData = new FormData();
    this.setState({ loadingBtn: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[id_pengguna]", this.state.id_pengguna);
    formData.append("data[id_peran]", this.state.id_peran);
    formData.append("data[id_bp]", this.state.id_bp);
    if(this.state.id_peran === "3" || this.state.id_peran === 3){
      formData.append("data[id_organisasi]", this.state.id_sp);
    }else{
      formData.append("data[id_organisasi]", this.state.id_unit);
    }
    axios
      .post(AppConfig.SaveRole + session, formData)
      .then((res) => {
        this.setState({
          loadingBtn: false,
        });
        swal({
          title: "Sukses!",
          text: "Role berhasil ditambahkan!",
          icon: "success",
          button: "OK!",
        });
        this.modalURole(this.state.id_pengguna);
        this.closeModal2();
      })
      .catch((err) => {
        this.setState({
          loadingBtn: false,
        });
        swal({
          title: "Gagal!",
          text: "Gagal menambah role!",
          icon: "error",
          button: "OK!",
        });
      });
    }
  };

  // Delete Role ============================================================================
  showDialogDelete(id_pengguna, idunit, idperan) {
    // console.log(idpengguna, idorganisasi, idperan);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let ids = id_pengguna + "/" + idunit + "/" + idperan;
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        axios
          .delete(AppConfig.DeleteRole + ids + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.modalURole(this.state.id_pengguna);
            this.closeModal2();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            // alert("GAGAL")
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  onChangeSP = (e) => {
      if (e.target.value !== "") {
        var str = e.target.value;
        if (str.length > 2) {

          var formData = new FormData();
          formData.append("data[keyword]", e.target.value);
          formData.append("data[id_bp]", this.state.id_bp);

          let userdata = JSON.parse(localStorage.getItem("userdata"));
          let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
          let session = "";
          if (userdata) {
            session =
              "?id_pengguna=" +
              userdata.id_pengguna +
              "&id_unit=" +
              sessiondata.i_idunit +
              "&id_role=" +
              sessiondata.i_idrole;
          }
        axios
          .post(AppConfig.SearchPT + session, formData)
          .then((res) => {
            this.setState({ list_option_sp: res.data.result.data});
          })
          .catch((err) => {
            console.log(err);
          });
          this.setState({ spHide: false, nm_sp: e.target.text });
        } else {
          this.setState({
            nm_sp: e.target.text,
            spHide: true,
          });
        }
      } else {
        this.setState({
          nm_sp: e.target.text,
          spHide: true,
        });
      }
    };

  onClickSPvalue = (e) => {
        
    e.target.value = e.target.getAttribute('value');
    e.target.text = e.currentTarget.innerHTML;
    
    this.setState({ id_sp: e.target.value, nm_sp: e.target.text,  spHide: true, errors: []});
  }

  deletePT = (e) =>{
      e.preventDefault();
      this.setState({ id_sp: "", nm_sp: "", spHide: true});
  }

  // Layout ============================================================================
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    const jenisKelamin = [
      { value: "L", label: "Laki-laki" },
      { value: "P", label: "Perempuan" },
    ];
    const isApproved = [
      { value: "1", label: "Diterima" },
      { value: "2", label: "Ditolak" },
    ];
    const isActive = [
      { value: "1", label: "Ya" },
      { value: "2", label: "Tidak" },
    ];

    let ii = 0;
    let list_user_role = [];
    if (this.state.getUserRoles !== undefined) {
      for (var key_role in this.state.getUserRoles) {
        list_user_role[ii] = {
          result: this.state.getUserRoles[key_role],
        };
        ii++;
      }
    }
    let list_role = [];
    for (var obj in this.state.getRoles) {
      if (this.state.getRoles.hasOwnProperty(obj)) {
        list_role[ii] = {
          value: obj,
          label: this.state.getRoles[obj],
        };
        ii++;
      }
    }
    let list_unit = [];
    for (var val in this.state.getUnits) {
      if (this.state.getUnits.hasOwnProperty(val)) {
        list_unit[ii] = {
          value: val,
          label: this.state.getUnits[val],
        };
        ii++;
      }
    }

    let optionsBP = [];

    if(JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 0 || JSON.parse(localStorage.getItem("sessiondata")).i_idbp === "null"){
      optionsBP.push({ value: "0", label: "Semua" });
      optionsBP.push({ value: "1", label: "Akademik" });
      optionsBP.push({ value: "2", label: "Vokasi" });
    }else if(JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 1){
      optionsBP.push({ value: "1", label: "Akademik" });
    }else if(JSON.parse(localStorage.getItem("sessiondata")).i_idbp === 2){
      optionsBP.push({ value: "2", label: "Vokasi" });
    }

  let data_option = [];
    this.state.list_option_sp.map((list,i)=>{
        data_option.push(<div value={list.id_sp} style={{padding: '10px', backgroundColor: '#f4f4f4'}} className="bg-hover-primary text-hover-white" onClick={this.onClickSPvalue}>{list.nm_lemb}</div>);
    });

    return (
      <>
        <NoticeManajemenUser style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>Manajemen User</strong>
          <p>Pengaturan User SPMI</p>
        </NoticeManajemenUser>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <h2>Form Penambahan User</h2>
                </div>
              </div>
            </div>
          </div>
          {/*========================================== Form Add User ========================================== */}
          <Form
            className="needs-validation"
            onSubmit={this.handleSave}
            noValidate
          >
            {this.state.loadingForm === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* For turning off auto complete */}
                <input type="hidden" value="something" />
                <Form.Row>
                  <Form.Group as={Col} controlId="nm_pengguna">
                    <Form.Label>
                      Nama Lengkap <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nama Lengkap"
                      value={this.state.nm_pengguna}
                      onChange={(e) => this.onInputForm(e, "nm_pengguna")}
                      required
                    />
                    <div className="text-danger">
                      {this.state.errors.nm_pengguna}
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} controlId="jenis_kelamin">
                    <Form.Label>Jenis Kelamin</Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={false}
                      autoFocus={false}
                      options={jenisKelamin}
                      placeholder="Pilih Jenis Kelamin"
                      onChange={this.selectedGender}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="tempat_lahir">
                    <Form.Label>Tempat Lahir</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Tempat Lahir"
                      value={this.state.tempat_lahir}
                      onChange={(e) => this.onInputForm(e, "tempat_lahir")}
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="tgl_lahir">
                    <Form.Label>Tanggal Lahir</Form.Label>
                    <Form.Control
                      type="date"
                      placeholder="Tanggal Lahir"
                      value={this.state.tgl_lahir}
                      onChange={(e) => this.onInputForm(e, "tgl_lahir")}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="no_tel">
                    <Form.Label>No. Telp</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="No. Telp"
                      value={this.state.no_tel}
                      onChange={(e) => this.onInputForm(e, "no_tel")}
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="no_hp">
                    <Form.Label>No. HP (WhatsApp)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="No. HP (WhatsApp)"
                      value={this.state.no_hp}
                      onChange={(e) => this.onInputForm(e, "no_hp")}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} controlId="alamat">
                    <Form.Label>
                      Alamat Lengkap
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="ex: Jl Hj Syamsudin No.31, Kec. Ciomas, Kab. Bogor, Jawa Barat"
                      value={this.state.alamat}
                      onChange={(e) => this.onInputForm(e, "alamat")}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                   <Form.Group as={Col} controlId="username">
                    <Form.Label>
                      Username <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Username"
                      value={this.state.username}
                      autoComplete="username"
                      onChange={(e) => this.onInputForm(e, "username")}
                      required
                    />
                    <div className="text-danger">
                      {this.state.errors.username}
                    </div>
                    <div className="valid-feedback"></div>
                  </Form.Group>
                   <Form.Group as={Col} controlId="ym">
                    <Form.Label>
                      Alamat Email <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Alamat Email"
                      value={this.state.ym}
                      onChange={(e) => this.onInputForm(e, "ym")}
                      required
                    />
                    <div className="text-danger">
                      {this.state.errors.ym}
                    </div>
                  </Form.Group>
                </Form.Row>

                 <Form.Row>
                  <Form.Group as={Col} controlId="password">
                    <Form.Label>
                      Password <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={this.state.password}
                      autoComplete="new-password"
                      onChange={(e) => this.onInputForm(e, "password")}
                      required
                    />
                    <div className="text-danger">
                      {this.state.errors.password}
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} controlId="passwordconf">
                    <Form.Label>
                      Konfirmasi Password <span className="text-danger"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Konfirmasi Password"
                      value={this.state.passwordconf}
                      onChange={(e) => this.onInputForm(e, "passwordconf")}
                      required
                    />
                    <div className="text-danger">
                      {this.state.errors.passwordconf}
                    </div>
                  </Form.Group>
                </Form.Row>

                <div className="row">
                  <div className="col-md-12">
                    {
                      (JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 1 || JSON.parse(localStorage.getItem("sessiondata")).i_idrole === 10) ?
                        <div style={{ float: "right", marginLeft: "10px" }}>
                        <ButtonToolbar>
                          <span className="svg-icon svg-icon-2x svg-icon-white">
                            <Button
                              disabled={this.state.loadingBtn}
                              variant="primary"
                              type="submit"
                            >
                              Simpan
                              {this.state.loadingBtn && (
                                <i className="ml-2 mr-1 spinner spinner-white"></i>
                              )}
                              &nbsp;&nbsp;
                            </Button>
                          </span>
                        </ButtonToolbar>
                      </div>
                      :""
                    }
                    
                    <div style={{ float: "right" }}>
                      <ButtonToolbar>
                        <span className="svg-icon svg-icon-2x svg-icon-white">
                          <Link to="/user">
                            <Button
                              variant="secondary"
                              disabled={this.state.loadingBtn}
                            >
                              Kembali
                            </Button>
                          </Link>
                        </span>
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
          {/*========================================== End Form ========================================== */}
        </Card>

        {/*========================================== Begin Modal User Role ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalURole}
          backdrop="static"
          keyboard={false}
          onHide={this.closeModal1}
        >
          <Modal.Header closeButton>
            <Modal.Title>List User Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row" style={{ marginBottom: "20px" }}>
              <div className="col-md-12">
                <div style={{ float: "right" }}>
                  <ButtonToolbar>
                    <span className="svg-icon svg-icon-2x svg-icon-white">
                      <Button
                        variant="primary"
                        onClick={() => this.modalAddURole()}
                      >
                        <i
                          className="flaticon-add"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                        &nbsp; Tambah Role
                      </Button>
                    </span>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
            {/*========================================== Begin Table ========================================== */}
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <tr>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Nama Role
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Nama Unit
                  </th>
                  <th
                    className="text-center"
                    style={{
                      width: "100px",
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                    }}
                  >
                    Aksi
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.loadingList === true ? (
                  <tr>
                    <td colSpan="3">
                      <LinearProgress color="secondary" variant="query" />
                    </td>
                  </tr>
                ) : list_user_role.length > 0 ? (
                  list_user_role.map((list) => (
                    <tr key={list.result.id_peran}>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        {list.result.nm_peran}
                      </td>
                      <td
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        {list.result.nm_organisasi}
                      </td>
                      <td className="text-center">
                        <ButtonToolbar
                          onClick={() =>
                            this.showDialogDelete(
                              list.result.id_pengguna,
                              list.result.id_organisasi,
                              list.result.id_peran
                            )
                          }
                          className="btn btn-icon btn-danger btn-sm"
                          style={{
                            minWidth: "50px",
                            marginLeft: "10px",
                            borderRadius: "12px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon-delete"
                              style={{
                                color: "#FFFFFF",
                                fontSize: "14px",
                              }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <tr>
                      <td colSpan="2" style={{ textAlign: "center" }}>
                        <em>Data does not exist</em>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            {list_user_role.length > 0 ? (
              <Link to="/user">
                <Button variant="primary">Kembali ke list User</Button>
              </Link>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal User Role ========================================== */}

        {/*========================================== Begin Modal Add Role ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalAddURole}
          backdrop="static"
          keyboard={false}
          onHide={this.closeModal2}
        >
          <Modal.Header>
            <Modal.Title>Assign Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <Form>
                  <Form.Group as={Col} controlId="roleSelect">
                    <Form.Label>Role <span className="text-danger">*</span></Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable={true}
                      autoFocus={true}
                      options={list_role}
                      placeholder="Cari nama role"
                      onChange={this.selectedRole}
                    />
                    <div className="text-danger">
                      {this.state.errors.id_peran}
                    </div>
                  </Form.Group>
                  {
                    (this.state.id_peran === "2013" || this.state.id_peran === "2014") ?
                    <Form.Group as={Col} controlId="unitSelect">
                      <Form.Label>Unit <span className="text-danger">*</span></Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable={true}
                        autoFocus={false}
                        options={list_unit}
                        placeholder="Cari nama unit"
                        onChange={this.selectedUnit}
                      />
                      <div className="text-danger">
                        {this.state.errors.id_unit}
                      </div>
                    </Form.Group>
                    :""
                  }
                  
                    <Form.Group as={Col} controlId="roleSelect">
                      <Form.Label>Bentuk Pendidikan  <span className="text-danger">*</span></Form.Label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isSearchable={true}
                        autoFocus={true}
                        options={optionsBP}
                        placeholder="Cari bentuk pendidikan"
                        onChange={this.selectedBp}
                      />
                      <div className="text-danger">
                        {this.state.errors.id_bp}
                      </div>
                    </Form.Group>
                    {
                      (this.state.id_peran === "3" && this.state.id_bp !== "") ?
                      <Form.Group as={Col} controlId="unitSelect">
                        <Form.Label>Perguruan Tinggi  <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Cari nama atau kode perguruan tinggi ..."
                          value={this.state.nm_sp}
                          onChange={(e) => this.onChangeSP(e)}
                          required
                        />
                        <div hidden={this.state.spHide}>
                            {data_option}
                        </div>
                        {
                          (this.state.id_sp !== "") ?
                          <div className="text-danger text-right">
                            <button
                              type="button"
                              className="btn mt-2 btn-danger text-weight-bold"
                              style={{fontSize: '11px'}}
                              onClick={this.deletePT} 
                            >
                              <i
                                className="flaticon-delete"
                                style={{ color: "#FFFFFF", fontSize: "11px" }}
                              ></i>
                              Hapus Perguruan Tinggi
                            </button>
                          </div>
                          :""
                        }
                        <div className="text-danger">
                          {this.state.errors.id_sp}
                        </div>
                      </Form.Group>
                      :""
                    }
                </Form>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleSubmitRole}
                disabled={this.state.loadingBtn}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                Simpan
                {this.state.loadingBtn && (
                  <i className="ml-3 spinner spinner-white"></i>
                )}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.closeModal2}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Add Role ========================================== */}
      </>
    );
  }
}

export default ManajemenUser;
